import { bouquetsAPI } from "../../../../entities/bouquets/api/bouquets-api";

export const bouquetsListApi = {
    getBouquets: async (page?: number, limit?: number) => {
        try {
            const response = await bouquetsAPI.getAll();

            // Базовая валидация ответа
            if (!response) {
                throw new Error('Invalid response format');
            }
            console.log(response)
            return response;
        } catch (error) {
            throw new Error('Не удалось загрузить список букетов');
        }
    }
};